import { cn } from "@/lib/utils";
interface CategoryCardProps {
  title: string;
  image: string;
  href?: string;
  className?: string;
  featured?: boolean;
}
export const CategoryCard = ({
  title,
  image,
  href = "#",
  className,
  featured = false
}: CategoryCardProps) => {
  return <a href={href} aria-label={title} className={cn("relative block overflow-hidden group bg-black", featured && "md:scale-105 z-10")}>
      {/* Image */}
      <img loading="lazy" decoding="async" src={image} alt={title} className="w-full h-80 md:h-full transition-transform duration-700 group-hover:scale-105 object-contain" />
      
      {/* Overlay */}
      <div className={cn("absolute inset-0 bg-gradient-to-t from-background/70 via-background/10 to-transparent md:from-background/90 md:via-background/20", featured && "from-background via-background/40 to-transparent")} />
      
      {/* Merchandise Label */}
      <div className="absolute top-4 left-4">
        
      </div>
      
      {/* Title */}
      <div className="absolute bottom-6 left-6 right-6">
        <h3 className={cn("font-serif text-xl md:text-2xl text-foreground", featured && "text-2xl md:text-3xl font-bold text-primary")}>
          {title}
        </h3>
      </div>
    </a>;
};